export default __webpack_public_path__ + "static/media/ios-share.84f362db.svg";